/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  Tabs,
  DatePicker,
  InputNumber,
} from 'antd';
import { CheckCircleOutlined, NumberOutlined, UserOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
// Se eliminaron imports de nivelesDeEstudios ya que no parecen usarse en este componente específico
// o se reemplazaron por la lógica de Autorización
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  getAutorizacionContratacion,
  patchAutorizacionContratacion,
  postAutorizacionContratacion,
  autorizarAutorizacionContratacion,
  getAutorizacionesContrataciones, // Si la usas
} from 'api/autorizarContrataciones'; // Asegúrate que la ruta sea correcta

import moment from 'moment/moment';
import { getEmpleados } from 'api/estructuraOrganizacional/empleados';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlaza } from 'api/catalogos/plazas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import currencyFormatter from 'utils/currencyFormatter';
import { putAutorizarContratacionMasiva } from 'api/autorizarContratacionesDetalles';
import { getLimitacionesAutorizacionContrataciones } from 'api/usuarios/limitacionAutorizacionContrataciones';
import { obtenerMiPasoDeAutorizacion } from 'utils/pasoAutorizacion';
import AutorizacionDetalleModal from './AutorizacionDetalleModal';

export const niveldeestudioPermission = {
  permissionModel: 'niveldeestudio', // Quizás quieras cambiar esto a 'autorizacion_contratacion' si tienes permisos específicos
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;

const CandidatoAutorizacion = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [esEmpleadoMunicipio, setEsEmpleadoMunicipio] = useState(false);
  const [observaciones, setObservaciones] = useState('');
  const [selectedData, setSelectedData] = useState([]);
  const [tipoAutorizacion, setTipoAutorizacion] = useState(null);
  const [visibleDetalle, setVisibleDetalle] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pasoAutorizacionContratacion, setPasoAutorizacionContratacion] = useState(null);
  const TAB_PENDIENTES = 'pendientes';
  const TAB_CONTRATADOS = 'contratados';

  const [activeTab, setActiveTab] = useState(TAB_PENDIENTES);
  const [originalData, setOriginalData] = useState([]);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getAutorizacionesContrataciones();
    setOriginalData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getAutorizacionesContrataciones(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setOriginalData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    obtenerMiPasoDeAutorizacion(getLimitacionesAutorizacionContrataciones)
      .then(setPasoAutorizacionContratacion);
  }, []);

  const requiereObservacionesContratacion = !!pasoAutorizacionContratacion?.requiere_observaciones;

  // AutorizacionContratacion puede venir de un Candidato o de un Becario (y en teoría de un
  // Honorario Asimilado, aunque _finalizar_autorizacion_contratacion no lo maneja todavía).
  // Un Candidato ya "Contratado(a)" se identifica por estado_del_candidato.id === 7; un
  // Becario no tiene ese catálogo de etapas de reclutamiento -- su contratación ya
  // finalizada se identifica por su propio estados_globales === ESTATUS_AUTORIZADO
  // (ver BecarioModelSerializer.update(), que crea el Empleado en ese momento).
  const yaFinalizado = (item) => {
    if (item.candidato) return item.candidato.estado_del_candidato?.id === 7;
    // BecarioModelSerializer.to_representation serializa estados_globales como
    // objeto anidado ({id, descripcion, ...}, ver EstadosGlobalesModelSerializer
    // en entidad/serializers/becario.py), no como el ID plano -- compararlo
    // directo contra ESTATUS_AUTORIZADO (un número) siempre daba false, así
    // que un Becario ya autorizado se quedaba mostrado como "Pendiente" para
    // siempre aunque ya estuviera resuelto en base de datos.
    if (item.becario) return item.becario.estados_globales?.id === ESTATUS_AUTORIZADO;
    return false;
  };

  useEffect(() => {
    if (!originalData) return;

    let filtered = [];

    switch (activeTab) {
      case TAB_PENDIENTES:
        filtered = originalData.filter((item) => !yaFinalizado(item));
        break;

      case TAB_CONTRATADOS:
        filtered = originalData.filter((item) => yaFinalizado(item));
        break;

      default:
        filtered = originalData;
    }

    // Actualizamos la tabla y limpiamos las selecciones
    setData(filtered);
    setSelectedRowKeys([]);
    setSelectedRows([]);
  }, [activeTab, originalData]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _contratacion = await getAutorizacionContratacion(match.id);
    setTimeout(() => {
      if (_contratacion) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_contratacion));
          setDisableFields(_contratacion?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();

      //  Normalizar fechas: convertir moment a string YYYY-MM-DD
      if (values.fecha_seleccion) {
        values.fecha_seleccion = values.fecha_seleccion.format('YYYY-MM-DD');
      }
      if (values.fecha_contratacion) {
        values.fecha_contratacion = values.fecha_contratacion.format('YYYY-MM-DD');
      }

      Object.keys(values).forEach((key) => {
        if (values[key] === '') {
          values[key] = null;
        }
      });

      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchAutorizacionContratacion(key, values)
        : postAutorizacionContratacion(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const handleOnRowClick = (record) => {
    const isSelected = selectedRowKeys.includes(record.id);

    let newKeys;
    let newRows;

    if (isSelected) {
      // Si ya está seleccionado → lo quitamos
      newKeys = selectedRowKeys.filter((id) => id !== record.id);
      newRows = selectedRows.filter((row) => row.id !== record.id);
    } else {
      // Si no está → lo agregamos
      newKeys = [...selectedRowKeys, record.id];
      newRows = [...selectedRows, record];
    }

    setSelectedRowKeys(newKeys);
    setSelectedRows(newRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
    type: 'checkbox',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const handleClickAutorizar = (nivel) => {
    setTipoAutorizacion(nivel);
    setVisibleAutorizar(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;

      await new Promise((resolve) => { setTimeout(resolve, 1000); });

      message.success(`Autorización Nivel ${tipoAutorizacion} realizada con éxito (Maquetado)`);

      onCancel();
      // await fetchData(); // Descomentar si usas la API real
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Candidatos / Becarios',
      children: [
        {
          title: 'Número',
          dataIndex: 'candidato',
          key: 'numero',
          width: 100,
          align: 'center',
          render: (candidato, record) => record.becario?.numero_de_becario
            || candidato?.id
            || record.id,
        },
        {
          title: 'Foto',
          dataIndex: 'id',
          key: 'foto',
          width: 80,
          align: 'center',
          render: () => <UserOutlined style={{ fontSize: '20px' }} />,
        },
        {
          title: 'Nombre',
          dataIndex: 'candidato',
          width: 300,
          render: (candidato, record) => record.becario?.numero_y_nombre_completo
            || candidato?.numero_y_nombre_completo
            || record.numero_y_nombre_completo,
        },
        {
          title: 'Referente',
          dataIndex: 'candidato',
          key: 'referente',
          width: 150,
          render: (candidato, record) => candidato?.referente
            || record.becario?.referente
            || '—',
        },
        {
          title: 'Fuente de Reclutamiento',
          dataIndex: 'candidato',
          key: 'fuente',
          width: 250,
          render: (candidato, record) => candidato?.fuente_de_reclutamiento?.descripcion
            || record.becario?.fuente_de_reclutamiento?.descripcion
            || '—',
        },
      ],
    },
    {
      titleText: 'Plazas Solicitadas',
      children: [
        {
          title: 'Fecha de Solicitud',
          dataIndex: 'candidato',
          key: 'fecha_solicitud',
          width: 150,
          render: (candidato) => candidato?.solicitud_de_contratacion?.fecha_de_solicitud || '—',
        },
        {
          title: 'Área',
          dataIndex: 'candidato',
          key: 'area',
          width: 300,
          render: (candidato, record) => candidato?.solicitud_de_contratacion
            ?.directorio_de_area_adscripcion_plaza?.clave_y_nombre
            || candidato?.solicitud_de_contratacion
              ?.directorio_de_area_adscripcion_plaza?.nombre
            || record.becario?.solicitud_de_contratacion
              ?.directorio_de_area_adscripcion_plaza?.clave_y_nombre
            || '—',
        },
        {
          title: 'Plaza',
          dataIndex: 'candidato',
          key: 'plaza',
          width: 300,
          render: (candidato) => candidato?.solicitud_de_contratacion?.plaza?.clave_y_descripcion
            || candidato?.solicitud_de_contratacion?.plaza?.descripcion
            || '—',
        },
        {
          title: 'Motivo',
          dataIndex: 'candidato',
          key: 'motivo',
          width: 250,
          render: (candidato) => candidato
            ?.solicitud_de_contratacion?.motivo_de_reclutamiento?.nombre
            || candidato?.solicitud_de_contratacion?.motivo_de_reclutamiento?.descripcion
            || '—',
        },
        {
          title: 'Sueldo Mensual',
          dataIndex: 'candidato',
          key: 'sueldo',
          width: 150,
          align: 'right',
          render: (candidato) => currencyFormatter(
            candidato?.solicitud_de_contratacion?.plaza
              ?.sueldo_mensual_nominal_asignado || 0,
          ),
        },
        {
          title: 'Estatus',
          dataIndex: 'candidato',
          key: 'estados_globales',
          width: 150,
          render: (candidato, record) => {
            if (candidato) {
              const estadoCandidatoId = candidato?.estado_del_candidato?.id;
              const estadoCandidatoDesc = candidato?.estado_del_candidato?.descripcion;

              if (estadoCandidatoId === 7) {
                return estadoCandidatoDesc || 'CONTRATADO(A)';
              }
              return 'Pendiente';
            }

            if (record.becario) {
              if (record.becario.estados_globales?.id === ESTATUS_AUTORIZADO) {
                return estados.find((e) => e.id === ESTATUS_AUTORIZADO)?.descripcion || 'AUTORIZADO(A)';
              }
              return 'Pendiente';
            }

            return 'Pendiente';
          },
        },
      ],
    },
  ];

  const handleClickVerAutorizaciones = () => {
    setVisibleDetalle(true);
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  const onAutorizarMasivo = async () => {
    if (requiereObservacionesContratacion && !observaciones.trim()) {
      message.error('Las observaciones son requeridas para este paso de autorización');
      return;
    }
    try {
      setLoading(true);
      const [idAutorizacion] = selectedRowKeys;

      const payload = selectedRows.map((item) => ({
        id: item.id,
        observaciones: observaciones || '',
      }));

      // 1. Guardamos el resultado en una variable
      const response = await putAutorizarContratacionMasiva(idAutorizacion, payload);

      // 2. FILTRO DE SEGURIDAD (Aquí está la solución al "falso positivo")
      if (!response) {
        return;
      }

      message.success('Autorizaciones realizadas con éxito');

      setVisibleAutorizar(false);
      setSelectedRows([]);
      setSelectedRowKeys([]);
      setObservaciones('');
      fetchData();
    } catch (err) {
      // putAutorizarContratacionMasiva ya normaliza y muestra el error vía
      // onError() (utils/handlers.js) antes de relanzarlo. Mostrarlo otra vez
      // aquí asumiendo que err.response.data.message siempre es un string
      // producía "Objects are not valid as a React child" cuando el backend
      // respondía {"message": {"non_field_errors": [...]}} (p. ej. un
      // AutorizacionContratacionDetalle duplicado), tumbando toda la pantalla.
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>

        {/* === INICIO DE LAS PESTAÑAS (TABS) === */}
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          items={[
            {
              key: TAB_PENDIENTES,
              label: 'Pendientes',
              children: (
                <Table
                  cols={columns}
                  data={data}
                  rowSelection={{
                    ...rowSelection,
                    type: 'checkbox',
                  }}
                  handleOnRowClick={handleOnRowClick}
                  controls={{
                  // onClickAdd,
                  // onClickEdit: () => onClickEdit(),
                  // onClickDelete,
                  }}
                  customActions={[
                    {
                      text: `Autorizar (${selectedRows.length})`,
                      icon: <CheckCircleOutlined />,
                      disabled: selectedRows.length === 0,
                      className: 'primary',
                      onClick: () => setVisibleAutorizar(true),
                    },
                    {
                      onClick: handleClickVerAutorizaciones,
                      text: 'Autorizar / Ver Detalle',
                      disabledBySelection: true, // Requiere seleccionar una fila
                      className: 'primary',
                    },
                  ]}
                  disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
                  permission={permission}
                  allowExportPDF={false}
                />
              ),
            },
            {
              key: TAB_CONTRATADOS,
              label: 'Contratados',
              children: (
                <Table
                  cols={columns}
                  data={data}
                  rowSelection={{
                    ...rowSelection,
                    type: 'checkbox',
                  }}
                  handleOnRowClick={handleOnRowClick}
                  controls={{}}
                  customActions={[
                    {
                      onClick: handleClickVerAutorizaciones,
                      text: 'Ver Detalle',
                      disabledBySelection: true,
                      className: 'primary',
                    },
                  ]}
                  disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
                  permission={permission}
                  allowExportPDF={false}
                />
              ),
            },
          ]}
        />

        {/* Modales (ModalDelete, ModalConfirmation, etc.) */}

        <AutorizacionDetalleModal
          open={visibleDetalle}
          onClose={() => setVisibleDetalle(false)}
          idAutorizacion={selectedRowKeys[0]} // Pasamos el ID seleccionado
          candidatoNombre={selectedData?.candidato_numero_y_nombre_completo}
        />

        <Modal
          open={visibleAutorizar}
          centered
          onOk={onAutorizarMasivo}
          onCancel={() => setVisibleAutorizar(false)}
          okText="Autorizar"
          width="40%"
          title="Confirmar Autorización Masiva"
        >
          <p>
            Se autorizarán:
            <strong>
              {' '}
              {selectedRows.length}
              {' '}
            </strong>
            registro(s)
          </p>

          <Input.TextArea
            rows={4}
            placeholder={`Observaciones de autorización${requiereObservacionesContratacion ? ' (requerido)' : ''}`}
            value={observaciones}
            status={requiereObservacionesContratacion && !observaciones.trim() ? 'error' : undefined}
            onChange={(e) => setObservaciones(e.target.value)}
          />
        </Modal>

      </Spin>
    </Row>
  );
};

export default CandidatoAutorizacion;
